import { render, staticRenderFns } from "./casedocuments.vue?vue&type=template&id=507a838f&"
import script from "./casedocuments.vue?vue&type=script&lang=js&"
export * from "./casedocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports